import { Filter } from "../Models/Filter";

// ===============================================================================

/**
 * A FilterCheck is a class that checks to see if an object passes a given filter. 
 * This class is abstract and its children should handle specific filtering (e.g. Search,
 * Category, etc.)
*/
export abstract class FilterCheck<TData> {

    // ===============================================================================

    protected _activeFilter: Filter;

    // ===============================================================================

    constructor(activeFilter: Filter) {
        this._activeFilter = activeFilter;
    }

    // ===============================================================================

    public getActiveFilter() {
        return this._activeFilter;
    }

    // ===============================================================================

    /**
     * Abstract method to be overriden by subclasses. Given an object to check, determine
     * if that model passes a filter.
     * 
     * @param object the object to check
     */
    public abstract passesCheck(object: TData): boolean;
}

// ===============================================================================

/**
 * A FilterCheckWithContext is a class that checks to see if an object passes a given filter. 
 * This class is abstract and its children should handle specific filtering (e.g. Search,
 * Category, etc.). This class also takes in a context which helps in determining if an
 * object passes a filter.
*/
export abstract class FilterCheckWithContext<TData, TContext> extends FilterCheck<TData>{
    protected _context: TContext;

    constructor(activeFilter: Filter, context: TContext) {
        super(activeFilter);
        this._context = context;
    }
}
